const CategoriesMenu = () => {
  const openers = [...document.querySelectorAll(".header__categories-btn")];
  const menu = document.querySelector(".categories-menu");
  const body = document.body;

  if (openers.length !== 0 && menu) {
    const closer = menu.querySelector(".categories-menu__closer-btn");

    openers.forEach(opener => {
      opener.addEventListener("click", () => {
        body.classList.toggle("no-scroll");
        menu.classList.toggle("opened");
        opener.classList.toggle("opened");
      });
    });

    if (closer) {
      closer.addEventListener("click", () => {
        body.classList.remove("no-scroll");
        menu.classList.remove("opened");
        openers.forEach(opener => opener.classList.remove("opened"));
      });
    }
  }
}

export default CategoriesMenu;

